import { Box, FormikTextInput } from '@palmetto/palmetto-components';
import { Field, useFormikContext } from 'formik';

import { AllDocumentTypes, DocumentTypes, ProgramType } from 'types';

import { UtilityNameSelectInput } from '../Account/UtilityNameSelectInput';
import FormSection from '../Forms/FormSection';
import { UtilityBillDescription } from '../InstallMilestonePackage/InstallationFormSectionDescriptions';

import { DocumentList } from './Documents/DocumentList';

type UtilityBillProps = {
  originContext?: string;
  allowArchive?: boolean;
  account: any;
  showCheckboxes?: boolean;
  checkboxCategories?: AllDocumentTypes[];
  isPackageEditable?: boolean;
  isUtilityBillApprovedDuringNtp?: boolean;
  hideDocumentUpload?: boolean;
};

export const UtilityBill = ({
  originContext,
  allowArchive,
  account,
  showCheckboxes = false,
  checkboxCategories = [],
  isPackageEditable = true,
  isUtilityBillApprovedDuringNtp = false,
  hideDocumentUpload = false,
}: UtilityBillProps) => {
  const isNewCommunity = account?.programType === ProgramType.newCommunity;
  const isNewHomes = account?.programType === ProgramType.newHomes;
  const { isSubmitting } = useFormikContext<any>();

  return (
    <FormSection
      title={isNewHomes ? 'Utility Information' : 'Utility Bill'}
      description={
        isUtilityBillApprovedDuringNtp || (!isNewHomes && !isNewCommunity && !hideDocumentUpload)
          ? UtilityBillDescription({
              showUtilityBill: !isNewHomes && !isNewCommunity && !hideDocumentUpload,
              isUtilityBillApprovedDuringNtp,
            })
          : undefined
      }
    >
      {!isNewHomes && !isNewCommunity && (
        <DocumentList
          documentTypeFilter={[DocumentTypes.utilityBill]}
          title="Utility Bill"
          showTypeLabelOnItems={false}
          baseCategory={'Utility Bill'}
          uploadContext={originContext}
          allowArchive={allowArchive}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          isPackageEditable={isPackageEditable}
          showUploadButton={!isUtilityBillApprovedDuringNtp && !hideDocumentUpload}
        />
      )}
      <Box direction="row">
        <UtilityNameSelectInput isDisabled={true} />
        <Field
          type="number"
          label="Tariff Id"
          name="tariffId"
          id="tariffId"
          component={FormikTextInput}
          autoComplete="off"
          isDisabled={isSubmitting || !isPackageEditable}
        />
      </Box>
    </FormSection>
  );
};
